const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.747 5.744 495.967 493.714",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 283.168 252.949 L 486.078 50 C 495.807 40.315 495.807 24.639 486.078 14.978 C 476.373 5.292 460.614 5.292 450.908 14.978 L 248.173 217.753 L 43.564 11.954 C 33.861 2.172 18.099 2.172 8.396 11.954 C -1.307 21.765 -1.307 37.639 8.396 47.422 L 212.856 253.07 L 7.658 458.299 C -2.047 467.985 -2.047 483.661 7.658 493.322 C 17.361 503.004 33.123 503.004 42.826 493.322 L 247.853 288.267 L 451.649 493.246 C 461.351 503.031 477.114 503.031 486.816 493.246 C 496.519 483.438 496.519 467.561 486.816 457.778 L 283.168 252.949 Z",
    id: "Close",
    style: {
      paintOrder: "fill",
      fill: "rgb(155, 242, 214)"
    },
    transform: "matrix(0, 1, -1, 0, 499.83741, 5.364868)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9ed92793f1a006f7ecf0bc7f316b7ed1.svg";
export { ForwardRef as ReactComponent };